import { ReactNode } from 'react';

import clsx from 'clsx';

export interface SelectorProps {
  children?: ReactNode;
  className?: string;
  isSelected?: boolean;
  selectorTitle: string;
  handleClick: (title: string) => void;
}

const Selector = ({
  children,
  className,
  isSelected,
  handleClick,
  selectorTitle,
}: SelectorProps) => {
  return (
    <span
      onClick={() => handleClick(selectorTitle)}
      className={clsx(
        'mt-2 w-full cursor-pointer rounded-[32px] px-6 py-2 font-montserrat font-medium text-brand-gray-100 transition-all duration-300 first-of-type:mt-0 hover:text-brand-primary-100 focus:bg-brand-primary-400 active:bg-brand-primary-400 motion-reduce:transition-none md:min-w-0 md:whitespace-nowrap',
        !isSelected && 'bg-brand-white-100 hover:bg-brand-gray-500',
        isSelected && 'bg-brand-primary-400 selection:bg-brand-primary-10070',
        className,
      )}
    >
      {children}
    </span>
  );
};

export default Selector;
